import { render, staticRenderFns } from "./EditLVPreis.vue?vue&type=template&id=971d65d4&"
import script from "./EditLVPreis.vue?vue&type=script&lang=js&"
export * from "./EditLVPreis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports